import { listResponse } from '../../utils/listResponse';
import { annotationSearchSchema } from '../models';
import { annotationListSideloadSchema } from '../models/annotationListSideload.schema';
import {
  annotationsSearchPayloadSchema,
  annotationsSearchQuerySchema,
} from './search.schema';

export type AnnotationsSearchQuery = Partial<{
  pageSize: number;
  searchAfter: string;
  ordering: string;
  'content.schema_id': string[];
}>;

// $ signs get stripped out during camelToSnake conversion from operators
// using simplified AnnotationsSearchPayload type and schema in request for now
// query is validated in the component level and is not used in the request in case of invalid shape
type QueryConditionModel = Record<string, unknown>;

export type AnnotationsSearchPayload = {
  query: QueryConditionModel;
  queryString?: {
    string: string;
  };
};

export const search = (
  query: AnnotationsSearchQuery = {},
  payload: AnnotationsSearchPayload
) => {
  return {
    endpoint: `/annotations/search`,
    method: 'POST',
    responseSchema: listResponse(annotationSearchSchema),
    query,
    querySchema: annotationsSearchQuerySchema,
    payload,
    payloadSchema: annotationsSearchPayloadSchema,
    sideloadSchema: annotationListSideloadSchema,
  } as const;
};
